import { z } from 'zod';

export const CandidateProfileTopFocusAreasSchema = z.object({
  topFocusAreas: z.array(z.string()),
  otherFocusAreas: z.array(z.string()),
  hiddenFocusAreas: z.array(z.string()),
});

export type CandidateProfileTopFocusAreas = z.infer<
  typeof CandidateProfileTopFocusAreasSchema
>;
